import { useTranslation } from '@context/TranslationContext'

const useT = (phrase) => {
    const t = useTranslation()
    return t[phrase] || phrase
}

export default useT